// Downloads por plataforma — edite aqui URLs, textos e dicas de instalação.
// APK Android servido pelo próprio site (public/masterx.apk).
// Alternativa caso o arquivo precise sair do repo: https://customer-assets-m6fa6gv7.emergentagent.net/job_clone-the-repo/artifacts/1b44e45ae253b7f5_masterx.apk

export const downloadApps = [
  {
    id: "android",
    platform: "Android",
    name: "MasterX HD",
    subtitle: "APK direto",
    description:
      "Aplicativo oficial MasterX HD. Funciona em celulares e tablets Android, Android TV, TV Box e Amazon Fire TV.",
    url: "/masterx.apk",
    fileName: "masterx.apk",
    cta: "Baixar APK",
    devices: ["TV Box", "Fire Stick", "Android TV", "Celular"],
    hint: "Ideal para TV Box e Fire Stick. Ative “Fontes desconhecidas”, baixe o masterx.apk, abra o arquivo e toque em Instalar.",
    downloads: 1247838,
    featured: true,
  },
  {
    id: "googleplay",
    platform: "Android",
    name: "Google Play",
    subtitle: "Loja oficial",
    description: "Para celulares, tablets e aparelhos Android com acesso à Play Store.",
    url: "https://play.google.com/store/search?q=master%20x&c=apps&hl=pt_BR",
    newTab: true,
    cta: "Abrir no Google Play",
    devices: ["Celular", "Tablet", "Android TV"],
    hint: "Baixe pela loja oficial Google Play: busque por “Master X”, instale e faça login com seu usuário e senha.",
  },
  {
    id: "windows",
    platform: "Windows PC",
    name: "MasterX para Windows",
    subtitle: "Microsoft Store",
    description: "App oficial MasterX na Microsoft Store para computador e notebook com Windows 10/11.",
    url: "https://apps.microsoft.com/store/detail/9N7HVS8LR0F4?cid=DevShareMWAPCBIL",
    newTab: true,
    cta: "Baixar na Microsoft Store",
    devices: ["Windows 10", "Windows 11"],
    hint: "Abra na Microsoft Store, clique em Instalar e faça login com seu usuário e senha.",
  },
  {
    id: "ios",
    platform: "iPhone / iPad",
    name: "Smarters Player Lite",
    subtitle: "App Store",
    description: "Para iPhone e iPad, instale o player oficial pela App Store.",
    url: "https://apps.apple.com/br/app/smarters-player-lite/id1628995509",
    newTab: true,
    cta: "Abrir na App Store",
    devices: ["iPhone", "iPad"],
    hint: "Instale pela App Store, abra o app e faça login com o usuário e senha enviados pelo WhatsApp.",
  },
];
